













































import { Component, Vue } from "vue-property-decorator";
import { configuration } from "@/config/host.config";
import { isSettingsOptionHidden } from "@/services/featureConfig";
import {
  IHotelConfig,
  IReviews,
  IWifiConfig,
} from "@/@types/filoxenia-config/tv-config";

import ReviewsConfigSettings from "./settings/reviews-config-settings.vue";
import HelloConfig from "./tv/hello-config.vue";
import WifiConfig from "@/components/card/internet-sources/wifi-config.vue";
import WeatherConfig from "./weather-configuration.vue";
import ConsentsConfigSettings from "./settings/consents-config-settings.vue";
import SkduConfigSettings from "./settings/skdu-config-settings.vue";
import GpsConfigSettings from "./settings/gps-config-settings.vue";

const opt = ["reviews", "hello", "wifi", "weather", "consents", "skdu", "gps"];

@Component({
  name: "settings-configuration",
  components: {
    reviews: ReviewsConfigSettings,
    hello: HelloConfig,
    WifiConfig,
    WeatherConfig,
    consents: ConsentsConfigSettings,
    SkduConfigSettings,
    GpsConfigSettings,
  },
})
class SettingsConfiguration extends Vue {
  option_id = "";
  isOptionHidden = isSettingsOptionHidden;
  reviews: IReviews | null = null;
  wifi_config: IWifiConfig | undefined;

  get optionList(): Array<string> {
    return opt.filter((o) => !isSettingsOptionHidden(o));
  }

  getOptionIcon(opt: string): string {
    const icons: Record<string, string> = {
      reviews: "star",
      hello: "emoji-smile",
      wifi: "wifi",
      weather: "cloud-sun",
      consents: "file-earmark-check",
      skdu: "diagram-3",
      gps: "geo-alt",
    };
    return icons[opt] || "gear";
  }

  async updateConfig(data: Partial<IHotelConfig>): Promise<void> {
    try {
      const config = { params: { app: "hotel" } };
      const configRes = await this.$axios.put(
        configuration.mainAPI,
        data,
        config
      );
      if (configRes.status === 200) {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        this.createConfigurationHotel();
      } else
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("alerts.emptyUpdate")),
          type: "warn",
        });
    } catch (error) {
      console.log(error);
    }
  }

  async createConfigurationHotel(): Promise<void> {
    try {
      const config = { params: { "match[app]": "hotel" } };
      const configRes = await this.$axios.get(configuration.mainAPI, config);
      if (configRes.status === 200) {
        if (configRes.data.hotel.reviews)
          this.reviews = configRes.data.hotel.reviews;
        if (configRes.data.hotel.wifi_config)
          this.wifi_config = configRes.data.hotel.wifi_config;
      }
    } catch (error) {
      console.log(error);
    }
  }

  mounted(): void {
    this.createConfigurationHotel();
  }
}
export default SettingsConfiguration;
